import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { guaranteeItems } from '../../data/lists';
export function Guarantee() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-198" data-mp="24moluttlfeg3">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-dashed border-forest/25 bg-paper px-5 py-10 text-center sm:px-10" data-id="element-199" data-mp="24l3rb47a3vi8">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-forest text-cream" data-id="element-200" data-mp="2ed9rh17opj8i">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-201" data-mp="2jbbefx88e2p9" />
        </span>
        <h2 className="mt-5 font-serif text-[30px] font-bold leading-tight text-forest sm:text-4xl" data-id="element-202" data-mp="2obh08wrtkuzf">Your 7-day guarantee</h2>
        <p className="mt-4 text-lg leading-relaxed text-ink/85" data-id="element-203" data-mp="2sbrfz15eyzrh">
          I want you to be able to explore REFLEXOLOGY 21-DAY PRACTICE METHOD™ without unnecessary risk. After purchasing,
          you'll be able to:
        </p>
        <ul className="mx-auto mt-6 grid max-w-lg gap-2 text-left sm:grid-cols-2" data-id="element-204" data-mp="xz1ik9fu78fc">
          {guaranteeItems.map(g => <li key={g} className="flex items-start gap-2 text-[15px] font-medium text-ink" data-id="element-205" data-mp="3nuq585xu1e5a">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-206" data-mp="3nsvgshncr3wg" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-base leading-relaxed text-muted" data-id="element-207" data-mp="3dy3lxll5mv5d">
          If within the first 7 days you decide this system isn't right for you, you can request a refund according to the
          purchase terms.
        </p>
        <p className="mt-3 font-serif text-lg font-semibold italic text-forest" data-id="element-208" data-mp="adqxjxphongt">
          No complicated process. Just a simple guarantee that allows you to explore the method with confidence.
        </p>
        <div className="mt-8" data-id="element-209" data-mp="k06cl1z9yxf">
          <CTAButton label="Try the 21-day reflexology method risk-free" note="7-Day Guarantee · One-time payment of $27" data-id="element-210" data-mp="2q7hftzupnky0" />
        </div>
      </div>
    </section>;
}